import type { NodeInstance } from '@glueapp/graph-types';
import { ApiServerLayout } from '@/GraphEditor/drawingLayer/nodeComposition/ApiServerLayout';

interface Props {
    nodeInstance: NodeInstance;
}

export const ApiServerNode: React.FC<Props> = ({ nodeInstance }) => {
    return <ApiServerLayout nodeInstance={nodeInstance} />;
};
